import React from 'react'

const Footer = () => (
  <footer id="footer">
    <p className="copyright">
      &copy; Amrit Thapaliya ·{' '}
      <a
        href="https://www.linkedin.com/in/amrit-thapaliya/"
        target="_blank"
        rel="noopener noreferrer"
      >
        LinkedIn
      </a>
      {' · '}
      <a
        href="https://github.com/Amrit-thapaliya"
        target="_blank"
        rel="noopener noreferrer"
      >
        GitHub
      </a>
    </p>
  </footer>
)

export default Footer
